import Api from '../Api'
import {
    PRODUCT_IMPORT_ADD_SKU,
    PRODUCT_IMPORT_BATCH_DONE,
    PRODUCT_IMPORT_CHUNK_COMPLETED,
    PRODUCT_IMPORT_FAILURE,
    PRODUCT_IMPORT_IN_PROGRESS,
    PRODUCT_IMPORT_QUEUE_FETCHING,
    PRODUCT_IMPORT_QUEUE_FETCHING_FAILURE,
    PRODUCT_IMPORT_QUEUE_FETCHING_SUCCESS,
    PRODUCT_IMPORT_REMOVE_SKU,
    PRODUCT_IMPORT_SUCCESS,
} from './types'

export const addSku = sku => dispatch => {
    dispatch({ type: PRODUCT_IMPORT_ADD_SKU, sku })
}

export const removeSku = sku => dispatch => {
    dispatch({ type: PRODUCT_IMPORT_REMOVE_SKU, sku })
}

export const importProduct = sku => dispatch => {
    dispatch({ type: PRODUCT_IMPORT_IN_PROGRESS, skus: [sku] })

    Api.importProductFromVerto(sku)
        .then(response => {
            dispatch({
                type: PRODUCT_IMPORT_QUEUE_FETCHING_SUCCESS,
                payload: response.data,
            })
        })
        .catch(error => {
            dispatch({
                type: PRODUCT_IMPORT_QUEUE_FETCHING_FAILURE,
                error,
            })
        })
}

/**
 * @param {String[]} skus
 * @param {Number} chunkSize
 * @param {Number} concurrency
 */
export const importProducts = (
    skus,
    chunkSize = 5,
    concurrency = 3
) => async dispatch => {
    const chunks = []
    for (let i = 0; i < skus.length; i += chunkSize) {
        chunks.push(skus.slice(i, i + chunkSize))
    }

    dispatch({
        type: PRODUCT_IMPORT_IN_PROGRESS,
        skus,
        totalChunks: chunks.length,
    })

    const errors = []

    for (let i = 0; i < chunks.length; i += concurrency) {
        const batch = chunks.slice(i, i + concurrency)
        const results = await Promise.all(
            batch.map(chunk =>
                Api.importProductsFromVerto(chunk)
                    .then(response => ({
                        ok: true,
                        data: response.data,
                        chunk,
                    }))
                    .catch(error => ({ ok: false, error, chunk }))
            )
        )

        results.forEach(result => {
            if (result.ok) {
                dispatch({
                    type: PRODUCT_IMPORT_QUEUE_FETCHING_SUCCESS,
                    payload: result.data,
                })
            } else {
                errors.push({ skus: result.chunk, error: result.error })
            }
            dispatch({ type: PRODUCT_IMPORT_CHUNK_COMPLETED })
        })
    }

    if (errors.length > 0) {
        dispatch({
            type: PRODUCT_IMPORT_QUEUE_FETCHING_FAILURE,
            errors,
            failedSkus: errors.flatMap(e => e.skus),
        })
    }

    dispatch({ type: PRODUCT_IMPORT_BATCH_DONE })
}

/**
 * @param {Number} page
 * @param {Number} pageSize
 */
export const getImportQueue = (page, pageSize) => dispatch => {
    dispatch({ type: PRODUCT_IMPORT_QUEUE_FETCHING })

    Api.getImportQueue(page, pageSize)
        .then(response => {
            dispatch({
                type: PRODUCT_IMPORT_QUEUE_FETCHING_SUCCESS,
                payload: response.data,
            })
        })
        .catch(error => {
            dispatch({
                type: PRODUCT_IMPORT_QUEUE_FETCHING_FAILURE,
                error,
            })
        })
}
